import { StyleSheet } from 'react-native';
import { spacing, ticketColors, ticketFonts, typography } from '../theme/public-api';

export const csvImportExportModalStyles = StyleSheet.create({
  modalCard: {
    maxHeight: '92%',
    overflow: 'hidden',
  },
  /** Preview / guía en PC: más aire que el card genérico (760). */
  modalCardWide: {
    maxWidth: 1100,
  },
  /** Header nuevo estilo: la card queda flush para que el borde del header llegue a los bordes. */
  modalCardFlush: {
    padding: 0,
    gap: 0,
  },
  scrollContent: {
    flexShrink: 1,
  },
  scrollContentInner: {
    paddingHorizontal: spacing.lg,
    paddingBottom: spacing.xl,
    gap: spacing.sm,
  },
  subtitle: {
    ...typography.body,
    color: ticketColors.ink2,
    paddingHorizontal: spacing.lg,
    marginBottom: spacing.sm,
  },
  readOnlyHint: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  donePanel: {
    gap: spacing.md,
    paddingVertical: spacing.sm,
  },
  doneHero: {
    alignItems: 'center',
    gap: spacing.xs,
    paddingVertical: spacing.sm,
  },
  doneHeadline: {
    ...typography.title3,
    color: ticketColors.ink,
    fontWeight: '700',
    textAlign: 'center',
  },
  doneDetail: {
    ...typography.body,
    color: ticketColors.ink2,
    textAlign: 'center',
    lineHeight: 22,
  },
  doneBreakdown: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 8,
    backgroundColor: ticketColors.paper,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    gap: spacing.xs,
  },
  doneBreakdownLine: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '500',
  },
  doneFootnote: {
    ...typography.caption,
    color: ticketColors.ink3,
    textAlign: 'center',
  },
  guideNote: {
    ...typography.body,
    color: ticketColors.ink,
    lineHeight: 22,
  },
  metaLine: {
    ...typography.caption,
    color: ticketColors.ink3,
  },
  inlineLink: {
    alignSelf: 'flex-start',
    paddingVertical: 2,
  },
  inlineLinkText: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '500',
  },
  hintsPanel: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 8,
    overflow: 'hidden',
    marginTop: spacing.xs,
  },
  hintsToggle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    backgroundColor: ticketColors.paper,
  },
  hintsToggleLabel: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '600',
  },
  hintsTable: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  hintsHeaderRow: {
    flexDirection: 'row',
    paddingVertical: 4,
    paddingHorizontal: spacing.sm,
    backgroundColor: ticketColors.bg,
  },
  hintsDataRow: {
    flexDirection: 'row',
    paddingVertical: 3,
    paddingHorizontal: spacing.sm,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  hintsCell: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  hintsColName: {
    flex: 1,
    gap: 2,
  },
  hintsFormatNote: {
    ...typography.caption,
    color: ticketColors.ink3,
    lineHeight: 16,
  },
  hintsColReq: {
    width: 118,
    textAlign: 'right',
  },
  hintsMono: {
    fontFamily: 'monospace',
    color: ticketColors.ink,
  },
  previewHint: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  csvPagerBar: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingVertical: spacing.xs,
  },
  csvPagerChips: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },
  csvPagerChip: {
    minWidth: 36,
    alignItems: 'center',
  },
  csvPagerSummary: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontVariant: ['tabular-nums'],
  },
  csvPagerNavInline: {
    flexDirection: 'row',
    gap: spacing.xs,
  },
  csvPagerNavBtn: {
    minWidth: 44,
    minHeight: 32,
    paddingHorizontal: spacing.sm,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
  },
  csvPagerBtnDisabled: {
    opacity: 0.4,
  },
  csvPagerBtnText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  actionRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    marginTop: spacing.sm,
  },
  actionBtn: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
  },
  actionBtnLabel: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
    flexShrink: 1,
  },
  importBtn: {
    marginTop: spacing.sm,
    flexDirection: 'row',
    gap: spacing.sm,
    justifyContent: 'center',
    alignItems: 'center',
  },
  fileName: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  statsWrap: {
    gap: spacing.xs,
  },
  statsPillRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },
  statsPill: {
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 5,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    borderRadius: 8,
    backgroundColor: ticketColors.paper,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.ruleSoft,
  },
  statsPillNew: {
    backgroundColor: 'rgba(61, 214, 140, 0.08)',
    borderColor: 'rgba(61, 214, 140, 0.23)',
  },
  statsPillError: {
    backgroundColor: 'rgba(255, 107, 107, 0.08)',
    borderColor: 'rgba(255, 107, 107, 0.23)',
  },
  statsPillAviso: {
    backgroundColor: 'rgba(232, 168, 56, 0.10)',
    borderColor: 'rgba(232, 168, 56, 0.28)',
  },
  statsPillValue: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  statsPillValueNew: {
    color: ticketColors.ok,
  },
  statsPillValueError: {
    color: ticketColors.bad,
  },
  statsPillValueAviso: {
    color: ticketColors.gold,
  },
  statsPillLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
  },
  statsAllEqual: {
    ...typography.body,
    fontWeight: '600',
    color: ticketColors.ink2,
  },
  statsMuted: {
    ...typography.caption,
    color: ticketColors.ink3,
  },
  previewControls: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.md,
  },
  previewEmptyNote: {
    ...typography.caption,
    color: ticketColors.ink3,
    paddingVertical: spacing.sm,
  },
  previewTable: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 8,
    overflow: 'hidden',
  },
  previewHeaderRow: {
    flexDirection: 'row',
    backgroundColor: ticketColors.paper,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.xs,
  },
  previewDataRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    paddingVertical: 6,
    paddingHorizontal: spacing.xs,
    minHeight: 44,
  },
  previewDataRowExpanded: {
    backgroundColor: ticketColors.paper,
  },
  previewCell: {
    ...typography.caption,
    fontSize: 12,
    lineHeight: 16,
    color: ticketColors.ink,
  },
  previewCellFila: {
    width: 32,
    flexShrink: 0,
    fontVariant: ['tabular-nums'],
    paddingTop: 2,
  },
  previewCellAccionCol: {
    width: 72,
    flexShrink: 0,
    paddingTop: 1,
  },
  previewCellDetalle: {
    flex: 1,
    minWidth: 0,
  },
  previewDetailMono: {
    fontFamily: 'monospace',
    color: ticketColors.ink2,
  },
  previewDetailExpanded: {
    color: ticketColors.ink,
    lineHeight: 18,
  },
  previewBadge: {
    alignSelf: 'flex-start',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    backgroundColor: ticketColors.paper,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.ruleSoft,
    maxWidth: 56,
  },
  previewBadgeCompact: {
    maxWidth: 52,
  },
  previewBadgeAlta: {
    backgroundColor: 'rgba(61, 214, 140, 0.09)',
    borderColor: 'rgba(61, 214, 140, 0.25)',
  },
  previewBadgeEdicion: {
    backgroundColor: ticketColors.paper,
    borderColor: ticketColors.ruleSoft,
  },
  previewBadgeError: {
    backgroundColor: 'rgba(255, 107, 107, 0.09)',
    borderColor: 'rgba(255, 107, 107, 0.25)',
  },
  previewBadgeIgual: {
    backgroundColor: ticketColors.paper,
    borderColor: ticketColors.ruleSoft,
  },
  previewBadgeAviso: {
    backgroundColor: 'rgba(232, 168, 56, 0.12)',
    borderColor: 'rgba(232, 168, 56, 0.35)',
  },
  previewBadgeText: {
    fontSize: 11,
    lineHeight: 14,
    fontWeight: '600',
    color: ticketColors.ink,
  },
  previewBadgeTextAlta: {
    color: ticketColors.ok,
  },
  previewBadgeTextEdicion: {
    color: ticketColors.ink,
  },
  previewBadgeTextError: {
    color: ticketColors.bad,
  },
  previewBadgeTextIgual: {
    color: ticketColors.ink3,
  },
  previewBadgeTextAviso: {
    color: ticketColors.gold,
  },
  footerActions: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.sm,
    paddingBottom: spacing.md,
    backgroundColor: ticketColors.bg,
    marginTop: 0,
  },
  actionRowStacked: {
    flexDirection: 'column',
  },
  actionBtnStacked: {
    minWidth: '100%',
    flex: undefined,
    width: '100%',
  },
});
